<template>
    <div class="maxCollapse">
        <position-list :pageLimit="pageLimit" v-if="order == 'open'" :providerId="providerId" :providerName="providerName" :order="order" :modifyTradeID="modifyTradeID" @modifyTrder="modifyTrade" :currency_pair="currency_pair"></position-list>
        <order-list :pageLimit="pageLimit" v-show="order == 'pending'" :order="order" @modifyOrder="modifyOrder" :modifyOrderID="modifyOrderID"></order-list>
        <trade-history :pageLimit="pageLimit" v-if="order == 'history'" :order="order"></trade-history>
        <trade-logs :pageLimit="pageLimit" v-if="order == 'transition-history'" :order="order"></trade-logs>
    </div>
</template>
<script>
    import positionList from './position-list'
    import orderList from './order-list'
    import tradeHistory from './trade-history'
    import tradeLogs from './trade-logs'
    import { commonAllmixins } from '@/plugins/commonAll'
    // import { Const } from '@/plugins/vue-provider-cache/const.mod'
    // import moment from 'moment'
export default {
    name: 'home-view',
    mixins: [commonAllmixins],
    props : ['providerId','providerName','modifyTradeID','modifyOrderID', 'currency_pair'],
    emits : ['modify-trade'],
    data() {
        return {
            order: 'open',
            pageLimit : 5
        }
    },
    components:{
        positionList,
        orderList,
        tradeHistory,
        tradeLogs
    },
    methods:{
        modifyTrade(v){
            this.$emit('modifyTrder',v);
        },
        modifyOrder(v){
            this.$emit('modifyOrder',v);
        }
    },
    /*props:{
        pageLimit:{
            type: Number,
            default: 5
        }
    }*/
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/order/order-history.vue